// src/pages/produtos/combos/ApresentacaoCad.js
import React, { useState, useEffect } from 'react';
import { MdDelete } from "react-icons/md";
import { IoMdAddCircle } from "react-icons/io";
import { useApresentacao } from '../../../contexts/produtos/combos/ApresentacaoContext';
import Input from '../../../components/input/Input';
import { useMessage } from '../../../contexts/geral/MessageContext';
import { useYesNo } from '../../../contexts/geral/YesNoContext';
import ModalContainer from '../../../components/modalForm/ModalContainer';
import ModalBody from '../../../components/modalForm/ModalBody';
import ModalFooter from '../../../components/modalForm/ModalFooter';
import ModalHeader from '../../../components/modalForm/ModalHeader';
import ApresentacaoSearch from './ApresentacaoSearch';
import { Apresentacao } from '../../../models/produtos/combos/Apresentacao';
import { useApresentacaoConjunto } from '../../../contexts/produtos/combos/ApresentacaoConjuntoContext';
import ApresentacaoConjuntoCad from './ApresentacaoConjuntoCad';
import ModalActions, { ModalActionButton } from '../../../components/modalForm/ModalActions';

const ApresentacaoCad = ({ show, onHide }) => {
    const { apresentacoes, addApresentacao, updateApresentacao, deleteApresentacao } = useApresentacao();
    const {apresentacaoConjuntos, deleteApresentacaoConjunto, fetchApresentacaoConjuntos} = useApresentacaoConjunto();
    const [apresentacao, setApresentacao] = useState(new Apresentacao());
    const { showMessage } = useMessage();
    const { showYesNo } = useYesNo();
    const [showSearchModal, setShowSearchModal] = useState(false);
    const [novoReg, setNovoReg] = useState(false);
    const [showApresentacaoConjunto, setShowApresentacaoConjunto] = useState(false);

    useEffect(() => {
        if (show) {
            handleNovo();
        }
    }, [show]);

    const handleNovo = () => {
        setApresentacao(new Apresentacao());
        setNovoReg(true);
    };

    const handleEditar = (id) => {
        if (id === 0) {
            showMessage("Selecione uma apresentação para editar!");
            return;
        }
        setNovoReg(false);
    };

    const handleDelete = async (e) => {
        e.preventDefault();
        if (!apresentacao?.id) {
            showMessage("Selecione uma apresentação para excluir!");
        } else {
            const resposta = await showYesNo("Deseja excluir a apresentação selecionada?");
            if (resposta) {
                await deleteApresentacao(apresentacao.id);
                handleNovo();
            }
        }
    };

    const handleSave = async () => {
        try {
            if (!apresentacao.nome) {
                showMessage("Informe um nome para a apresentação!");
                return;
            }

            if (!apresentacao.id) {
                await addApresentacao(apresentacao);
            } else {
                await updateApresentacao(apresentacao);
            }
            handleNovo();
        } catch (error) {
            console.error("Erro ao gravar dados: ", error);
        }
    };

    const handleExit = () => {
        const apresentacaoSel = apresentacoes.find(a => a.id.toString() === apresentacao?.id?.toString());

        if (apresentacaoSel) {
            setApresentacao(apresentacaoSel);
            handleEditar(apresentacao?.id);
        } else {
            setApresentacao(new Apresentacao());
        }
    };

    const handleSelectApresentacao = (apresentacaoSel) => {
        setApresentacao(apresentacaoSel);
        setShowSearchModal(false);
        if (apresentacaoSel) {
            handleEditar(apresentacaoSel.id);
        } else {
            setApresentacao(new Apresentacao());
        }
    };

    const handleNovoConjunto = (e) => {
        e.preventDefault();
        if (apresentacao?.id) {         
            setShowApresentacaoConjunto(true);
        } else {
            showMessage('Selecione um conjunto!', 'warning');
        }
    };

    const handleRemoveConjunto = async (item) => {
        const resposta = await showYesNo("Deseja remover o item?");
        if (resposta) {
            await deleteApresentacaoConjunto(item.id);
        }
    };

    useEffect(() => {        
        fetchApresentacaoConjuntos(apresentacao?.id);        
    }, [apresentacao?.id]);

    if (!show) return null;

    return (
        <>
            <ModalContainer show={show} largura='600px' variant="cadastro" onHide={onHide}>
                <ModalHeader title={novoReg ? 'Nova Apresentação' : 'Alterar Apresentação'} onHide={onHide} />
                <ModalBody>
                    <form>
                        <div className="input-group" style={{ marginBottom: '10px', alignItems: 'end' }}>
                            <Input
                                label="Código"
                                value={apresentacao.id || ''}
                                onChange={(e) => setApresentacao({ ...apresentacao, id: e.target.value })}
                                onBlur={handleExit}
                                disabled={!novoReg}
                                btnBuscar={() => setShowSearchModal(true)}
                            />
                            <Input
                                label="Nome da Apresentação"
                                value={apresentacao.nome || ''}
                                onChange={(e) => setApresentacao({ ...apresentacao, nome: e.target.value })}
                                size={300}
                                autoFocus
                            />
                            <Input
                                label="Valor Adicional"
                                value={apresentacao.valorAdicional || ''}
                                onChange={(e) => setApresentacao({ ...apresentacao, valorAdicional: e.target.value })}
                            />
                            <Input
                                label="Descrição"
                                value={apresentacao.descricao || ''}
                                onChange={(e) => setApresentacao({ ...apresentacao, descricao: e.target.value })}
                                size={400}
                                rows={2}                                
                            />

                            {apresentacao?.id !== 0 && (
                            <div style={{ marginTop: "8px" }}>
                                <button
                                className="btn btn-secondary"                
                                onClick={handleNovoConjunto}
                                >
                                <IoMdAddCircle />Incluir Conjunto
                                </button>
                            </div>
                            )}
                        </div>
                        <div className="table-responsive">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Código</th>
                                        <th>Descrição</th>                                        
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>                                    
                                    {apresentacaoConjuntos.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.conjuntoId}</td>
                                            <td>{item.conjunto?.nome}</td>                                                                   
                                            <td>
                                                <button
                                                    type="button" // <-- ESSENCIAL
                                                    className="btn btn-danger btn-sm"
                                                    onClick={() => handleRemoveConjunto(item)}
                                                >
                                                <MdDelete />
                                                </button>

                                            </td>
                                        </tr>
                                    ))}
                                    {apresentacaoConjuntos.length === 0 && (
                                        <tr>
                                            <td colSpan="3" className="text-center">
                                                Nenhum item cadastrado
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </form>
                </ModalBody>
                <ModalFooter>
                    <ModalActions >
                        <ModalActionButton className="btn btn-primary" type="button" onClick={handleSave} action="save">
                            Salvar
                        </ModalActionButton>
                        <ModalActionButton className="btn btn-danger" type="button" onClick={handleDelete} disabled={novoReg} action="delete">
                            Excluir
                        </ModalActionButton>
                        <ModalActionButton className="btn btn-secondary" type="button" onClick={handleNovo} disabled={novoReg} action="new">
                            Novo
                        </ModalActionButton>
                    </ModalActions>
                </ModalFooter>

                <ApresentacaoSearch
                    show={showSearchModal}
                    onHide={() => setShowSearchModal(false)}
                    onSelectApresentacao={handleSelectApresentacao}
                />

                <ApresentacaoConjuntoCad
                    isOpen={showApresentacaoConjunto}
                    onClose={()=>setShowApresentacaoConjunto(false)}
                    apresentacaoId={apresentacao.id}
                />        
            </ModalContainer>
        </>
    );
};

export default ApresentacaoCad;